module.exports = __webpack_public_path__ + "media/components/src/assets/images/action-item/remove-a161cacd56769f55530d864bd2f338e2.svg";